"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBar = void 0;
var react_1 = __importDefault(require("react"));
var AnimationLink_1 = require("./AnimationLink");
var BorderLink_1 = require("./BorderLink");
var ColorsLink_1 = require("./ColorsLink");
var DisplayLink_1 = require("./DisplayLink");
var FlexLink_1 = require("./FlexLink");
var PositionLink_1 = require("./PositionLink");
var SizingLink_1 = require("./SizingLink");
var SpacingLink_1 = require("./SpacingLink");
var TextLink_1 = require("./TextLink");
var SideBar = function () { return (react_1.default.createElement("div", { className: "SideBar bg-light1 px6 pos-stick t8" },
    react_1.default.createElement(AnimationLink_1.AnimationLink, null),
    react_1.default.createElement(BorderLink_1.BorderLink, null),
    react_1.default.createElement(ColorsLink_1.ColorsLink, null),
    react_1.default.createElement(DisplayLink_1.DisplayLink, null),
    react_1.default.createElement(FlexLink_1.FlexLink, null),
    react_1.default.createElement(PositionLink_1.PositionLink, null),
    react_1.default.createElement(SizingLink_1.SizingLink, null),
    react_1.default.createElement(SpacingLink_1.SpacingLink, null),
    react_1.default.createElement(TextLink_1.TextLink, null))); };
exports.SideBar = SideBar;
